var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50391 8.00361C1.50391 4.41399 4.41387 1.50403 8.00349 1.50403C11.5931 1.50403 14.5031 4.41399 14.5031 8.00361C14.5031 11.5932 11.5931 14.5032 8.00349 14.5032C4.41387 14.5032 1.50391 11.5932 1.50391 8.00361ZM10.5302 7.00192C10.771 6.66487 10.6929 6.19645 10.3558 5.9557C10.0188 5.71494 9.55036 5.79301 9.3096 6.13007L7.42854 8.76356L6.61718 7.95219C6.32428 7.6593 5.84941 7.6593 5.55652 7.95219C5.26362 8.24509 5.26362 8.71996 5.55652 9.01285L6.99391 10.4502C7.1498 10.6061 7.36639 10.6855 7.5861 10.6674C7.80582 10.6492 8.0064 10.5352 8.13454 10.3558L10.5302 7.00192Z",
    fill: "#0E7241"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.679e621fef3bad0fa1808df2339c055a.svg";
export { ForwardRef as ReactComponent };